import React from 'react';
import { StarIcon } from 'lucide-react';
type StarsProps = {
  rating: number;
  reviews?: number;
  size?: 'sm' | 'md';
};
export function Stars({
  rating,
  reviews,
  size = 'sm'
}: StarsProps) {
  const icon = size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4';
  return <div className="flex items-center gap-1.5" data-id="element-361" data-mp="133fcd2zr5vh6">
      <div className="flex" aria-hidden="true" data-id="element-362" data-mp="y1ycnat08f26">
        {Array.from({
        length: 5
      }).map((_, i) => <StarIcon key={i} className={`${icon} ${i < Math.round(rating) ? 'fill-clay text-clay' : 'fill-line text-line'}`} strokeWidth={0} data-id="element-363" data-mp="adotyhr387f9" data-mpi={i} />)}
      </div>
      <span className={`${size === 'sm' ? 'text-xs' : 'text-sm'} text-muted`} data-id="element-364" data-mp="kbmh11x7ny6a">
        <span className="sr-only" data-id="element-365" data-mp="fbgv82dmh5w4">Beoordeling </span>
        {rating.toLocaleString('nl-NL')}
        {reviews !== undefined && <span data-id="element-366" data-mp="1voov9qbu8bna"> ({reviews})</span>}
      </span>
    </div>;
}